<template>
  <div class="funding-goal">
    <div class="target">
      <div class="-label">เป้าหมาย</div>
      <span class="-value">{{ target | comma }} บาท</span>
    </div>
    <div class="progress">
      <span class="percent -value"><span class="sr-only">สำเร็จแล้ว</span> {{ percent}}%</span>
      <div class="progress-bar" role="progressbar" :aria-valuenow="percent"
      aria-valuemin="0" aria-valuemax="100" :style="{ width: `${percent}%` }">
      </div>
    </div>
    <span class="-label" v-if="remaining > 0">เหลือเวลาอีก {{ remaining }} วัน</span>
  </div>
</template>
<script>

export default {
  name: 'FundingGoal',

  props: {
    target: {
      type: Number,
      default: 0
    },
    amount: {
      type: Number,
      default: 0
    },
    endDate: {
      type: String,
      default: ''
    }
  },

  computed: {
    remaining () {
      return this.$utils.getRemainingDays(this.endDate)
    },

    percent () {
      const percent = Math.floor((this.amount / this.target) * 100)
      if (!isNaN(percent)) {
        return percent
      }
      return 0
    }
  }
}
</script>

<style scoped lang="scss">


  .progress {
    height: 8px;
    margin-bottom: 8px;
    background-color: #D1D1D1;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    position: relative;
    .percent {
      position: absolute;
      top: -30px;
      right: 0;
    }
    .progress-bar {
      border-radius: 4px;
      float: left;
      width: 0;
      height: 100%;
      font-size: 12px;
      line-height: 20px;
      color: #fff;
      text-align: center;
      background-color: #F8941D;
      -webkit-transition: width .6s ease;
      -o-transition: width .6s ease;
      transition: width .6s ease;
      max-width: 100%;
      
    }
  }


  .-value {
    font-weight: 500;
    font-size: 1.1em;
    color: #3F3F3F;
  }
  .-label {
    font-weight: 300;
    color: #595959;
  }

</style>



// WEBPACK FOOTER //
// FundingGoal.vue?53ff0a02